import { Suspense, lazy } from "react";
import ScrollToTop from "./helpers/scroll-top";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";

// home pages
const HomeFashion = lazy(() => import("./pages/home/HomeFashion"));

// shop pages
const ShopGridStandard = lazy(() => import("./pages/shop/ShopGridStandard"));

// product pages
const Product = lazy(() => import("./pages/shop-product/Product"));

// blog pages
const BlogStandard = lazy(() => import("./pages/blog/BlogStandard"));
const BlogDetailsStandard = lazy(
  () => import("./pages/blog/BlogDetailsStandard"),
);

// other pages
const About = lazy(() => import("./pages/other/About"));
const Contact = lazy(() => import("./pages/other/Contact"));
const MyAccount = lazy(() => import("./pages/other/MyAccount"));
const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

const Cart = lazy(() => import("./pages/other/Cart"));
const Wishlist = lazy(() => import("./pages/other/Wishlist"));
const Compare = lazy(() => import("./pages/other/Compare"));
const Checkout = lazy(() => import("./pages/other/Checkout"));
const OrderConfirmation = lazy(() => import("./pages/other/OrderConfirmation"));
const TrackOrder = lazy(() => import("./pages/other/TrackOrder"));
const ShippingPolicy = lazy(() => import("./pages/other/ShippingPolicy"));
const RefundPolicy = lazy(() => import("./pages/other/RefundPolicy"));

const SearchResults = lazy(() => import("./pages/other/SearchResults"));

const NotFound = lazy(() => import("./pages/other/NotFound"));

const App = () => {
  useEffect(() => {
    document.documentElement.setAttribute("data-bs-theme", "light");
  }, []);
  return (
    <Router>
      <ScrollToTop>
        <Suspense
          fallback={
            <div className="flone-preloader-wrapper">
              <div className="flone-preloader">
                <span></span>
                <span></span>
              </div>
            </div>
          }
        >
          <Routes>
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={<HomeFashion />}
            />

            {/* Shop pages */}
            <Route
              path={process.env.PUBLIC_URL + "/shop"}
              element={<ShopGridStandard />}
            />
            {/* legacy shop URL, redirect to the new route */}
            <Route
              path={process.env.PUBLIC_URL + "/shop-grid-standard"}
              element={
                <Navigate to={process.env.PUBLIC_URL + "/shop"} replace />
              }
            />

            {/* Shop product pages */}
            <Route
              path={process.env.PUBLIC_URL + "/product/:id"}
              element={<Product />}
            />

            {/* Blog pages */}
            <Route
              path={process.env.PUBLIC_URL + "/blog"}
              element={<BlogStandard />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog/:id"}
              element={<BlogDetailsStandard />}
            />
            {/* legacy blog URLs, redirect to the new routes */}
            <Route
              path={process.env.PUBLIC_URL + "/blog-standard"}
              element={
                <Navigate to={process.env.PUBLIC_URL + "/blog"} replace />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/blog-details-standard"}
              element={
                <Navigate to={process.env.PUBLIC_URL + "/blog"} replace />
              }
            />

            {/* Other pages */}
            <Route
              path={process.env.PUBLIC_URL + "/about"}
              element={<About />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/contact"}
              element={<Contact />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/my-account"}
              element={<MyAccount />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/login-register"}
              element={<LoginRegister />}
            />

            <Route path={process.env.PUBLIC_URL + "/cart"} element={<Cart />} />
            <Route
              path={process.env.PUBLIC_URL + "/wishlist"}
              element={<Wishlist />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/compare"}
              element={<Compare />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/checkout"}
              element={<Checkout />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/order/confirmation"}
              element={<OrderConfirmation />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/track-order"}
              element={<TrackOrder />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/shipping-policy"}
              element={<ShippingPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/refund-policy"}
              element={<RefundPolicy />}
            />
            <Route
              path={process.env.PUBLIC_URL + "/search"}
              element={<SearchResults />}
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </Router>
  );
};

export default App;
